import Vue from 'vue'
import VeeValidate, { Validator } from 'vee-validate'

Validator.extend('creditcard_number', {
  validate: function(value) {
    if (!value) {
      return false
    }
    const spaceRemovedValue = value.replace(/ /g, '')
    return /^\d{16}$/.test(spaceRemovedValue)
  }
})

Validator.extend('positive_number', {
  validate: function(value) {
    if (!value || isNaN(value)) {
      return false
    }
    return parseInt(value) > 0
  }
})

Validator.extend('user_id_number', {
  validate: function(value) {
    if (!value) {
      return false
    }
    return /^\d*$/.test(value)
  }
})

Validator.extend('user_id_text', {
  validate: function(value) {
    if (!value) {
      return false
    }
    if (value.length < 3) {
      return false
    }
    return /^[A-Za-z0-9_]+$/.test(value)
  }
})

Validator.extend('creditcard_expiry', {
  validate: function(originalValue) {
    const value = originalValue.replace(/ /g, '')
    if (!value) {
      return false
    }
    // 숫자 4자리인지 확인
    if (!/^\d{2}\/\d{2}$/.test(value)) return false

    const m = parseInt(value.substr(0, 2), 10)
    const y = parseInt(value.substr(3), 10)

    // 12월 보다 큰지 확인
    if (m > 12) return false

    const date = new Date()
    const month = date.getMonth() + 1
    const year = date.getYear() - 100

    // 현재 연도 보다 작은지 확인
    if (y < year) return false

    // 현재 연도 일 경우 월이 더 적은지 확인
    if (y === year && m < month) return false

    return true
  }
})

Validator.extend('creditcard_cvc', {
  validate: function(value) {
    if (!value) {
      return false
    }
    return /^\d{3}$/.test(value)
  }
})

Validator.extend('system_alias', {
  validate: value => /^[a-z0-9_][a-z0-9_]+$/.test(value)
})

Validator.extend('key_string', {
  validate: value => /^[a-z0-9_][a-z0-9_]+$/.test(value)
})

Validator.extend('required', {
  validate: value => {
    if (value === null || value === undefined || value === '') {
      return false
    }

    if (Array.isArray(value)) {
      if (value.length === 0) {
        return false
      } else if (value[0].locale && value[0].locale.locale) {
        for (let i = 0; i < value.length; i++) {
          if (!value[i].charst) {
            return false
          }
        }
      }
    }
    if (value && value.type === 'map') {
      if (
        !value.address ||
        value.address.length === 0 ||
        !value.latlng ||
        value.latlng.length !== 2 ||
        (!value.latlng[0] && !value.latlng[1])
      ) {
        return false
      }
    }
    return true
  }
})

Validator.extend('business_registration_number', {
  validate: value => {
    if (!value) {
      return false
    }
    // 넘어온 값의 정수만 추츨하여 문자열의 배열로 만들고 10자리 숫자인지 확인합니다.
    if ((value = (value + '').match(/\d{1}/g)).length !== 10) {
      return false
    }

    // 합 / 체크키
    let sum = 0
    const key = [1, 3, 7, 1, 3, 7, 1, 3, 5]

    // 0 ~ 8 까지 9개의 숫자를 체크키와 곱하여 합에더합니다.
    for (let i = 0; i < 9; i++) {
      sum += key[i] * Number(value[i])
    }

    // 각 8번배열의 값을 곱한 후 10으로 나누고 내림하여 기존 합에 더합니다.
    // 다시 10의 나머지를 구한후 그 값을 10에서 빼면 이것이 검증번호 이며 기존 검증번호와 비교하면됩니다.
    return (
      10 - ((sum + Math.floor((key[8] * Number(value[8])) / 10)) % 10) ===
      Number(value[9])
    )
  }
})

Validator.extend('juridical_registration_number', {
  validate: value => {
    if (!value) {
      return false
    }
    const sRegNo = value.replace('-', '')

    if (sRegNo.length !== 13) {
      return false
    }

    const arrRegNo = sRegNo.split('')
    const arrWt = [1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2]
    let iSumRegNo = 0
    let iCheckDigit

    for (let i = 0; i < 12; i++) {
      iSumRegNo += parseInt(arrRegNo[i]) * parseInt(arrWt[i])
    }

    iCheckDigit = 10 - (iSumRegNo % 10)

    iCheckDigit = iCheckDigit % 10

    if (iCheckDigit !== parseInt(arrRegNo[12])) {
      return false
    }
    return true
  }
})

Validator.extend('inhabitants_identification_number', {
  validate: value => {
    if (!value) {
      return false
    }
    const jumin = value.replace('-', '')
    let chk = 0
    let i
    const lastNum = jumin.substring(12, 13)
    const chkNum = '234567892345'

    for (i = 0; i < 12; i++) {
      if (jumin.charAt(i) !== '-')
        chk += parseInt(chkNum.charAt(i)) * parseInt(jumin.charAt(i))
    }

    chk = (11 - (chk % 11)) % 10

    if (chk !== parseInt(lastNum)) {
      return false
    }

    return true
    // 출처: https://cocy.tistory.com/88 [cocy]
  }
})

Validator.extend('creditcard_required', {
  validate: value => {
    if (!value) {
      return false
    }

    return !(!value.number || !value.name || !value.expiry || !value.cvc)
  }
})

Validator.extend('creditcard_valid_date', {
  validate: value => {
    // 숫자 4자리인지 확인
    if (!/^\d{4}$/.test(value)) return false

    const m = parseInt(value.substr(0, 2), 10)
    const y = parseInt(value.substr(2), 10)

    // 12월 보다 큰지 확인
    if (m > 12) return false

    const date = new Date()
    const month = date.getMonth() + 1
    const year = date.getYear() - 100

    // 현재 연도 보다 작은지 확인
    if (y < year) return false

    // 현재 연도 일 경우 월이 더 적은지 확인
    if (y === year && m < month) return false

    return true
  }
})

Validator.extend('excludes', {
  validate: (value, params) => {
    if (params) {
      for (let i = 0; i < params.length; i++) {
        if (value === params[i]) {
          return false
        }
      }
    }
    return true
  }
})

const isUnique = (
  value,
  [module, item, key, inputRow, locale, menuAlias, column, uniqueUrl]
) => {
  const params = {
    search: {},
    inputRow: inputRow,
    locale: locale
  }
  if (column.inputControl.type === 'multiselect') {
    if (value) {
      if (value.data.id) {
        params.search[key] = value.data.id
      } else {
        params.search[key] = value.data
      }
    }
  } else {
    params.search[key] = value
  }
  if (!uniqueUrl) {
    uniqueUrl =
      module +
      '/manage/unique/' +
      item.toCamelCase() +
      '?menuAlias=' +
      menuAlias
  }

  return window.$axios
    .post(uniqueUrl, params, {
      no_loading: true
    })
    .then(response => {
      return {
        valid: response.data.resultCode === 'success'
      }
    })
}

Validator.extend('unique', isUnique, { hasTarget: true })

const isUniqueKey = (
  value,
  [module, item, info, values, me, menuAlias, uniqueUrl]
) => {
  if (!value) {
    return Promise.resolve({ valid: false })
  }
  if (values && values.length > 0) {
    for (let i = 0; i < values.length; i++) {
      if (values[i].id !== me.id) {
        if (values[i].keyString === value) {
          return false
        }
      }
    }
  }
  const params = {
    search: value,
    info: info
  }
  if (!uniqueUrl) {
    uniqueUrl =
      module +
      '/manage/uniqueKey/' +
      item.toCamelCase() +
      '?menuAlias=' +
      menuAlias
  }

  return window.$axios
    .post(uniqueUrl, params, {
      no_loading: true
    })
    .then(response => {
      return {
        valid: response.data.resultCode === 'success'
      }
    })
}

Validator.extend('unique_key', isUniqueKey, { hasTarget: true })

Validator.extend('password_confirm', {
  validate: (value, [otherValue]) => {
    return value === otherValue
  }
})

Validator.extend('cooperation_no', {
  validate: value => /^\d{3}-\d{2}-\d{5}$/.test(value)
})

Validator.extend('zip', {
  validate: value => /^\d{5}$/.test(value)
})

window.isTelFormat = function(value) {
  return (
    /^(([+0-9])[0-9 -]{1,}){0,}([0-9]){3,4}[-]([0-9]){4}$/.test(value) ||
    /^\+[0-9](?:[- ]?[0-9]){,14}$/.test(value)
  )
}

window.isEmailFormat = function(value) {
  return /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    value
  )
}

Validator.extend('tel', {
  validate: window.isTelFormat
})

Validator.extend('tel_or_email', {
  validate: function(value) {
    return window.isTelFormat(value) || window.isEmailFormat(value)
  }
})

Validator.extend('password', {
  validate: value =>
    /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[!@#$%^*+=-]).{6,20}$/.test(value)
})

Vue.mixin({
  methods: {
    getValidationRulesObject(column, module, item, inputRow) {
      const rules = this.parseValidationRules(
        column && column.inputControl ? column.inputControl.rules : undefined
      )
      if (column && column.inputControl && column.inputControl.required) {
        rules.required = true
      }
      if (rules.unique) {
        if (typeof rules.unique !== 'object') {
          rules.unique = [
            module,
            item.toCamelCase(),
            column.key,
            inputRow,
            this.$store.state.locale,
            this.getMenuAlias(),
            column
          ]
        } else if (Array.isArray(rules.unique)) {
          rules.unique = [
            module,
            item.toCamelCase(),
            column.key,
            inputRow,
            this.$store.state.locale,
            this.getMenuAlias(),
            column,
            rules.unique[0]
          ]
        } else {
          rules.unique[3] = inputRow
        }
      }
      return rules
    },
    hasValidationRules(rules) {
      if (rules) {
        if (typeof rules === 'string') {
          return rules.trim()
        }
        return Object.entries(rules).length > 0
      }
      return false
    },
    parseValidationRules: function(rules) {
      let retRules = {}
      if (rules) {
        if (rules && typeof rules === 'string') {
          const ruleList = rules.split('|')
          for (let i = 0; i < ruleList.length; i++) {
            if (ruleList[i].trim()) {
              if (ruleList[i].indexOf(':') >= 0) {
                const terms = ruleList[i].split(':')
                const rule = terms[0]
                const params = terms[1].split(',')
                retRules[rule] = params
              } else {
                retRules[ruleList[i]] = true
              }
            }
          }
        } else {
          retRules = window.copyObject(rules)
          for (const key in retRules) {
            if (retRules[key].withFields) {
              if (
                retRules[key].params &&
                Object.keys(retRules[key].params).length > 0
              ) {
                retRules[key] = retRules[key].params
              } else {
                retRules[key] = true
              }
            }
          }
        }
      }
      return retRules
    },
    contentsValidated: function(prefix) {
      let foundRefs = 0
      for (const ref in this.$refs) {
        if (!ref.startsWith(prefix)) {
          continue
        }
        if (
          ref === 'insertForm.userId' &&
          this.configs.user_id_validation_policy === 'before_registration' &&
          this.authcodeStatus !== 'verified'
        ) {
          return false
        }
        if (
          this.$refs[ref] &&
          this.$refs[ref].length > 0 &&
          !this.$refs[ref][0].isVisibleControl()
        ) {
          continue
        }
        if (
          this.$refs[ref] &&
          this.$refs[ref].length > 0 &&
          this.$refs[ref][0].readonly
        ) {
          continue
        }
        foundRefs++
        if (
          !this.$refs[ref] ||
          (Array.isArray(this.$refs[ref]) && this.$refs[ref].length === 0)
        ) {
          return false
        }

        let target
        if (Array.isArray(this.$refs[ref])) {
          target = this.$refs[ref][0]
        } else {
          target = this.$refs[ref]
        }
        if (target) {
          if (
            target.errors &&
            target.errors.count &&
            target.errors.count() > 0
          ) {
            return false
          }
          if (!this.requiredValidate(target)) {
            return false
          }
        } else if (
          this.$refs[ref].$children &&
          this.$refs[ref].$children.length > 0
        ) {
          if (!this.checkChildrenValidation(this.$refs[ref].$children)) {
            return false
          }
        }
      }
      if (foundRefs === 0) {
        return false
      }
      return true
    },
    checkChildrenValidation: function(children) {
      for (let i = 0; i < children.length; i++) {
        const child = children[i]
        if (child.errors && child.errors.count && child.errors.count() > 0) {
          return false
        }
        if (!this.requiredValidate(child)) {
          return false
        }
        if (child.$children && child.$children.length > 0) {
          if (!this.checkChildrenValidation(child.$children)) {
            return false
          }
        }
      }
      return true
    },
    requiredValidate(field) {
      if (!field) {
        return false
      }
      if (!field.required) {
        return true
      }
      if (
        field.value === null ||
        field.value === undefined ||
        field.value === ''
      ) {
        return false
      }

      if (field.type === 'i18n') {
        for (let i = 0; i < field.value.length; i++) {
          if (!field.value[i].charst) {
            return false
          }
        }
      }
      if (field.type === 'name') {
        const names = field.value.split(';')
        if (!names[0] || !names[2]) {
          return false
        }
      }
      return true
    },
    contentsInModalValidated: function(prefix) {
      let foundRefs = 0
      for (const ref in this.$refs) {
        if (!ref.startsWith(prefix)) {
          continue
        }
        foundRefs++
        if (!this.$refs[ref]) {
          return false
        }
        if (this.$refs[ref].readonly) {
          continue
        }
        if (
          this.$refs[ref].errors &&
          this.$refs[ref].errors.count &&
          this.$refs[ref].errors.count() > 0
        ) {
          return false
        }
        if (
          this.$refs[ref].required &&
          (!this.$refs[ref].value || this.$refs[ref].value.length === 0)
        ) {
          return false
        }
      }
      if (foundRefs === 0) {
        return false
      }
      return true
    }
  }
})

export default ({ app, store }) => {
  if (localStorage.locale) {
    app.$i18n.locale = localStorage.locale
  }
  VeeValidate.setI18nDriver('custom', app.$i18n)
  Vue.use(VeeValidate, {
    locale: app.$i18n.locale,
    fieldsBagName: 'veeFields'
  })
}
